import { TweenLite } from 'gsap'
import Circle from './pixi/circle'
import { onResize, log } from '../utilities'
import VideoPlayer from '../video-player'

const BACKGROUND_COLOR = 0xF7F7F5;

function colorAsInt (color){
    if ( !isNaN(color) ){
        return color;
    }
    if ( typeof color === 'string' ){
        while(color.charAt(0) === '#'){
            color = color.substr(1);
        }
        return parseInt(color, 16);
    }
    console.error('couldn\'t convert color ' + color + ' to int');
    return 0;
}

export default class
{
    constructor( container, shapesColor )
    {
        this.container = container;

        this.width = container.offsetWidth;
        this.height = container.offsetHeight;

        this.stage = new window.PIXI.Container();

        var options = {
            antialias: true,
            transparent: false,
            resolution: window.devicePixelRatio
        };

        this.renderer = window.PIXI.autoDetectRenderer( this.width, this.height, options);
        this.renderer.plugins.interaction.autoPreventDefault = false;
        this.renderer.backgroundColor = BACKGROUND_COLOR;

        this.renderer.view.style.width = this.width + 'px';
        this.renderer.view.style.height = this.height + 'px';
        container.insertBefore(this.renderer.view, container.firstChild);

        //this.dim = new Dim( BACKGROUND_COLOR, this.width, this.height );
        //this.stage.addChild( this.dim );

        this.__nextColor = colorAsInt(shapesColor);

        this.setupShapes();
        this.framesRendered = 0;
        this.shouldStop = false;
        this.render();
        setTimeout( ()=>{
            log('rendered: ' + this.framesRendered + ' frames');
            if( this.framesRendered < 30 ){
                this.removeMe();
            }
        }, 1000);

        onResize( (size)=> {
            //size.height -= VARS.BASELINE*VARS.NEXT_SECTION_HINT_ROWS;
            //size.height = Math.max( VARS.MIN_HOME_HEIGHT, size.height );
            //
            this.renderer.view.style.width = size.width + 'px';
            //this.renderer.view.style.height = size.height + 'px';
            this.renderer.resize( size.width, this.height );

            this.width = size.width;
            //this.height = size.height;
        }, true);
    }

    removeMe(){
        this.shouldStop = true;
        clearTimeout( this.nextShapePlanId );
        cancelAnimationFrame( this.requestAnimationId );
        this.removeAllInteractions();

        TweenLite.to( this.renderer.view, 1, {
            opacity: 0,
            onComplete: ()=>{
                this.container.removeChild(this.renderer.view);
            }
        })
    }

    nextColor(){
        return this.__nextColor;
    }

    setupShapes(){
        this.nextShapePlanId=0;
        this.lastTimeUserAddedShape = Date.now();

        this.addShape();

        this.bindedMoveTouch = this.didMoveTouch.bind(this);
        this.bindedReleaseTouch = this.didReleaseTouch.bind(this);
        this.bindedTouch = this.didTouch.bind(this);
        this.bindedMouseMove = this.didMoveMouse.bind(this);
        this.addInteraction();
    }

    addInteraction(){
        this.container.addEventListener('touchstart', this.bindedTouch );
        this.container.addEventListener('mousemove', this.bindedMouseMove);
    }

    removeInteractions () {
        this.container.removeEventListener('touchstart', this.bindedTouch );
        this.container.removeEventListener('mousemove', this.bindedMouseMove);
    }

    removeAllInteractions() {
        this.removeInteractions();

        this.container.removeEventListener( 'touchmove', this.bindedMoveTouch );
        this.container.removeEventListener( 'touchend', this.bindedReleaseTouch );
        this.container.removeEventListener( 'touchcancel', this.bindedReleaseTouch );
    }


    didMoveMouse(e){
        var t = Date.now();
        if( t - this.lastTimeUserAddedShape > 100 ){
            clearTimeout( this.nextShapePlanId );

            this.addShape( e );
            this.lastTimeUserAddedShape = t;

            this.planNextShape();
        }
    }

    didTouch(e){
        //console.log( 'mouse down' );
        clearTimeout( this.nextShapePlanId );

        this.addShape( e );
        this.lastTimeUserAddedShape = Date.now();

        this.container.addEventListener( 'touchmove', this.bindedMoveTouch );
        this.container.addEventListener( 'touchend', this.bindedReleaseTouch );
        this.container.addEventListener( 'touchcancel', this.bindedReleaseTouch );
    }

    didMoveTouch(e){
        //console.log( 'mouse move' );

        var t = Date.now();
        if( t - this.lastTimeUserAddedShape > 100 ){
            this.addShape( e );
            this.lastTimeUserAddedShape = t;
        }

    }

    didReleaseTouch(e){
        //console.log( 'mouse release' );

        this.container.removeEventListener( 'touchmove', this.bindedMoveTouch );
        this.container.removeEventListener( 'touchend', this.bindedReleaseTouch );
        this.container.removeEventListener( 'touchcancel', this.bindedReleaseTouch );

        this.planNextShape();
    }

    render(elapsedTime)
    {
        this.renderer.render(this.stage);
        this.framesRendered++;
        this.requestAnimationId = requestAnimationFrame( this.render.bind(this) );
    }

    addShape(e){
        if( this.shouldStop ){
            return;
        }
        if( document.hidden
            || VideoPlayer.isVisible
            || this.container.getBoundingClientRect().bottom < 0
        ){
            this.planNextShape();
            return;
        }
        let shape = new Circle( this.nextColor(), 1 );
        //let dimIndex = this.stage.getChildIndex( this.dim );
        this.stage.addChild( shape );

        if( e ){
            //console.log( e );
            var target = e;
            if( e.touches ){
                target = e.touches[0];
            }
            shape.x = target.pageX;
            shape.y = target.pageY;
        }else{
            shape.x = Math.random() * this.width;
            shape.y = Math.random() * this.height;
            if( !this.shouldStop ) {
                this.planNextShape();
            }
        }
    }

    planNextShape(){
        this.nextShapePlanId = setTimeout( this.addShape.bind(this), 1000 + Math.random()*1000 );
    }
}


/** WEBPACK FOOTER **
 ** ./src/js/home/background.js
 **/